import React, { FC, useEffect, useState } from 'react';
import { Checkbox, Col, Row, Select } from 'antd';
import { api, endpoints } from '../../../../api';
import { AppearBlock, CloseButton, CustomCheckbox, CustomSelect, FormItem } from '../../../../styles/styled';
import { SubjectAreaFormType, SubjectAreasType, SubjectsType } from '../../../NewApplicationPage/types';

type SubjectAreaProps = {
  removeForm: () => void;
  changeForm: (toChangeSubjectArea: SubjectAreaFormType, id: number) => void;
  id: number;
  currentSubjectArea?: SubjectAreaFormType;
};
const { Option } = Select;

export const SubjectAreaForm: FC<SubjectAreaProps> = ({ removeForm, changeForm, id, currentSubjectArea }) => {
  const [subjectAreasState, setSubjectAreas] = useState<SubjectAreasType>([]);
  const [subjectsState, setSubjects] = useState<SubjectsType>([]);

  useEffect(() => {
    (async () => {
      try {
        const subjectAreasResponse = await api.get<SubjectAreasType>(endpoints.getSubjectAreas());
        const subjectsResponse = await api.get<SubjectsType>(endpoints.getSubjects());

        if (!currentSubjectArea?.subject_area_general?.id) {
          changeForm(
            {
              ...currentSubjectArea,
              subjects_general: [],
              subject_area_general: { id: subjectAreasResponse.data[0].id },
            },
            id,
          );
        }

        setSubjects(subjectsResponse.data);
        setSubjectAreas(subjectAreasResponse.data);
      } catch (err) {}
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppearBlock padding="40px 20px">
      <CloseButton positioned onClick={() => removeForm()}>
        +
      </CloseButton>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <FormItem direction="row">
            <p>Предметная область</p>
            <CustomSelect
              showSearch
              value={
                subjectAreasState.find((el) => el.id === currentSubjectArea?.subject_area_general?.id)?.title || 'Все'
              }
              onChange={(value, option) => {
                changeForm(
                  {
                    ...currentSubjectArea,
                    subjects_general: [],
                    subject_area_general: { id: parseInt(Object.values(option)[0]) },
                  },
                  id,
                );
              }}
            >
              {subjectAreasState.map((el) => (
                <Option key={el.id} value={el.title}>
                  {el.title}
                </Option>
              ))}
            </CustomSelect>
          </FormItem>
        </Col>
      </Row>
      <br />
      <Row gutter={[20, 20]} wrap={true}>
        {!currentSubjectArea &&
          subjectsState.map((el) => (
            <Col key={el.id}>
              <CustomCheckbox>{el.title}</CustomCheckbox>
            </Col>
          ))}
        {currentSubjectArea &&
          subjectsState
            .filter((el) => el?.subject_area_general?.id === currentSubjectArea?.subject_area_general?.id)
            .map((el) => (
              <Col key={el.id}>
                <Checkbox
                  onChange={(e) =>
                    changeForm(
                      {
                        ...currentSubjectArea,
                        subjects_general: !e.target.checked
                          ? currentSubjectArea.subjects_general.filter((e) => e.id !== el.id)
                          : [...currentSubjectArea.subjects_general, { id: el.id }],
                      },
                      id,
                    )
                  }
                  checked={!!currentSubjectArea?.subjects_general?.find((e) => e.id === el.id)}
                >
                  {el.title}
                </Checkbox>
              </Col>
            ))}
      </Row>
    </AppearBlock>
  );
};
